import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NativeElementWithAction32yo3q41a36ui as NativeElementWithAction } from '../InteractiveElement.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { KeyboardHints3coyq4x1rsbe3 as KeyboardHints } from '../../models/data.mjs';
import { KeyCodes_instance1xpu3tad1ataj as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import {
  textInputDriverValue3q4tdt9119yf7 as textInputDriverValue,
  textInputDriverActions3hqh1ppdy4gus as textInputDriverActions,
} from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { applyKeyboardHints2y8fo0b5cldu1 as applyKeyboardHints } from './KeyboardHints.ext.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applyAlign($this, value) {
  var tmp0 = $this.native_1.style_1;
  var tmp;
  switch (value.ordinal_1) {
    case 0:
      tmp = 'start';
      break;
    case 1:
      tmp = 'center';
      break;
    case 2:
      tmp = 'end';
      break;
    case 3:
      tmp = 'justify';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'com.lightningkite.kiteui.views.textAlign' call
  var value_0 = tmp;
  tmp0.native_1.textAlign = value_0;
}
function TextInput$content$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  var tmp = $this$vprop.attributes_1.native_1.value;
  var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function TextInput$content$lambda_0($this$vprop, it) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  $this$vprop.attributes_1.native_1.value = it;
  return Unit_instance;
}
var TextInputClass;
function TextInput() {
  if (TextInputClass === VOID) {
    class $ extends NativeElementWithAction() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'input';
        this.native_1.classes_1.add_utx5q5_k$('editable');
        var tmp = this;
        var tmp_0 = this.native_1;
        var tmp_1 = TextInput$content$lambda;
        tmp.content_1 = vprop(tmp_0, 'input', tmp_1, TextInput$content$lambda_0);
        this.keyboardHints_1 = new (KeyboardHints())();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.native_1;
        var tmp0_safe_receiver = this_0.element_1;
        var tmp_2;
        if (tmp0_safe_receiver == null) {
          tmp_2 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver = this.action_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp_3 = this_0.eventsBack_1['on' + 'keyup'];
          var old = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
          var tmp_4 = 'on' + 'keyup';
          this_0.eventsBack_1[tmp_4] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.get_enter_iqxcq7_k$()) {
              var tmp0_safe_receiver_0 = this.action_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.startAction_u0zgbm_k$(this);
              }
            }
            return Unit_instance;
          };
        }
        this._align_1 = null;
      }
      get_driverValue_yh5neo_k$() {
        return textInputDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), textInputDriverActions(this));
      }
      set_keyboardHints_w6k1he_k$(value) {
        this.keyboardHints_1 = value;
        applyKeyboardHints(this.native_1, value);
      }
      set_align_ypalx0_k$(value) {
        this._align_1 = value;
        applyAlign(this, value == null ? get_theme(this).font_1.align_1 : value);
      }
      nativeApplyTheme_6heplg_k$(theme) {
        super.nativeApplyTheme_6heplg_k$(theme);
        var tmp0_elvis_lhs = this._align_1;
        applyAlign(this, tmp0_elvis_lhs == null ? theme.theme_1.font_1.align_1 : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'TextInput');
    TextInputClass = $;
  }
  return TextInputClass;
}
//region block: exports
export {
  TextInput as TextInput22lgsa81snd26,
};
//endregion

//# sourceMappingURL=TextField.commonHtml.mjs.map
